import BaseAPI from "./BaseAPI";

class VidazooAppsAPI extends BaseAPI {

	public async getApps() {
		return (await this.request({
			method: "get",
			url: `/api/apps/`,
		})).data;
	}

}

export default new VidazooAppsAPI(window.__CAPITAL_API_URL__);
